var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2551 30.7796C23.896 30.7796 23.5386 30.6694 23.2311 30.4498L16 25.2641L8.76885 30.4498C8.46925 30.6654 8.10921 30.7808 7.74014 30.7795C7.37107 30.7782 7.01183 30.6603 6.71374 30.4427C6.41536 30.2264 6.19281 29.9215 6.07774 29.5713C5.96268 29.2212 5.96097 28.8437 6.07285 28.4925L8.76974 19.7885L1.60351 14.7387C1.30652 14.5196 1.08595 14.2125 0.973017 13.8611C0.860079 13.5097 0.860486 13.1317 0.974181 12.7805C1.08877 12.4302 1.31056 12.1248 1.6082 11.9073C1.90584 11.6899 2.26427 11.5716 2.63285 11.569L11.5084 11.5556L14.3342 3.06763C14.4508 2.71796 14.6745 2.41384 14.9735 2.19834C15.2725 1.98284 15.6318 1.86688 16.0004 1.86688C16.369 1.86688 16.7283 1.98284 17.0273 2.19834C17.3263 2.41384 17.55 2.71796 17.6666 3.06763L20.4444 11.5556L29.3653 11.569C29.7343 11.571 30.0933 11.6894 30.3912 11.9071C30.6892 12.1248 30.9109 12.4309 31.025 12.7819C31.139 13.1328 31.1396 13.5108 31.0266 13.8621C30.9136 14.2134 30.6928 14.5201 30.3955 14.7387L23.2293 19.7885L25.9262 28.4925C26.0383 28.8436 26.0368 29.2211 25.9219 29.5712C25.807 29.9214 25.5845 30.2264 25.2862 30.4427C24.9872 30.6621 24.6259 30.7801 24.2551 30.7796Z",
    fill: "#FFBB0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/Star-Icon.d62883a191752f12fe0c3cdc99c2b4be.svg";
export { ForwardRef as ReactComponent };